import { apiCall } from "./auth";
import { API_URL } from "./config";


export const buildStAdd = (data) => apiCall(`${API_URL}BuildSt/buildStAdd`, "POST",data)
export const buildStUpdate = (data) => apiCall(`${API_URL}BuildSt/buildStUpdate`, "POST", data)
export const buildStGet = (data) => apiCall(`${API_URL}BuildSt/buildStGet`, "POST", data)
export const BuildStGetById = (data) => apiCall(`${API_URL}BuildSt/BuildStGetById`, "POST", data)